module.exports = __webpack_public_path__ + "static/media/BoyNeonXRosa_GraceBeck-23.85a4e10b.JPG";